var React = require('react');

function CropAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 24a24 24 0 0 0-24-24H88a24 24 0 0 0-24 24v392a32 32 0 0 0 32 32h224v-96H160zm328 328h-40v96h40a24 24 0 0 0 24-24v-48a24 24 0 0 0-24-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 64H192v96h160v328a24 24 0 0 0 24 24h48a24 24 0 0 0 24-24V96a32 32 0 0 0-32-32zM0 88v48a24 24 0 0 0 24 24h40V64H24A24 24 0 0 0 0 88z","className":"fa-primary","key":2})]);
}

CropAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CropAlt;

CropAlt.default = CropAlt;
